export var ZIndex;
(function (ZIndex) {
    ZIndex[ZIndex["Elevated"] = 100] = "Elevated";
    ZIndex[ZIndex["Affix"] = 200] = "Affix";
    ZIndex[ZIndex["Tooltip"] = 300] = "Tooltip";
    ZIndex[ZIndex["Dragging"] = 400] = "Dragging";
    ZIndex[ZIndex["Modal"] = 500] = "Modal";
})(ZIndex || (ZIndex = {}));
//# sourceMappingURL=ZIndex.js.map